module.exports = __webpack_public_path__ + "static/media/auth-speed.78c3b2e5.png";